/*
 * @Author: 邱狮杰
 * @Date: 2022-09-27 11:57:57
 * @LastEditTime: 2022-11-01 14:13:45
 * @Description:
 * @FilePath: /superbridal-repo/packages/service/src/api/customer/customer.ts
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject } from 'inversify';
import { provide } from 'inversify-binding-decorators';
import 'reflect-metadata';
import { CreateCrudVariable } from '../../utils/createCrudVariable';
export const customerConstant = new CreateCrudVariable().setUpThemes('Customer').getTopic();
let Customer = class Customer {
    constructor(read, update, deletes, create) {
        this.create = create;
        this.delete = deletes;
        this.update = update;
        this.read = read;
    }
    getCreateTrigger() {
        return this.create;
    }
    getUpdateTrigger() {
        return this.update;
    }
    getDeleteTrigger() {
        return this.delete;
    }
    getReadTrigger() {
        return this.read;
    }
};
Customer = __decorate([
    provide(customerConstant.createCustomer),
    __param(0, inject(customerConstant.createRead)),
    __param(1, inject(customerConstant.createUpdate)),
    __param(2, inject(customerConstant.createDelete)),
    __param(3, inject(customerConstant.createCreate)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], Customer);
export { Customer };
